import React, { useEffect, useMemo, useState } from 'react';
import GetAppIcon from '@material-ui/icons/GetApp';
import { Button } from '@spark/ui-components/components/Button';
import DisponibilidadeMotoristaFilter from './DisponibilidadeMotoristaFilter';
import DisponibilidadeMotoristaTable from './DisponibilidadeMotoristaTable';
import MotoristaAvailabilityCard from './MotoristaAvailabilityCard';
import { useDisponibilidadeMotoristaPanel } from '../hooks/useDisponibilidadeMotoristaPanel';
import { isSameSelection } from '../utils/selection';
import {
  ButtonIconWrap,
  PanelSection,
  SectionHeader,
  SectionTitle
} from '../DisponibilidadeFrota-styled';

const PainelDisponibilidadeMotorista = ({ titulo, tituloFiltro, tipo, exportFileName, sheetName, data, loading, selecaoAtiva, onToggleSelection }) => {
  const [expandedCardKey, setExpandedCardKey] = useState(null);
  const {
    filterConfig,
    dataFiltrada,
    paginaAtual,
    quantidadePorPagina,
    setPaginaAtual,
    setQuantidadePorPagina,
    handleApplyFiltros,
    handleExportar,
    podeSelecionar
  } = useDisponibilidadeMotoristaPanel({
    tipo,
    exportFileName,
    sheetName,
    data,
    selecaoAtiva
  });
  const visibleCardKeys = useMemo(
    () => new Set(dataFiltrada.map(item => item?.codigo || item?.cpf || item?.motorista || '')),
    [dataFiltrada]
  );

  useEffect(() => {
    if (expandedCardKey && !visibleCardKeys.has(expandedCardKey)) {
      setExpandedCardKey(null);
    }
  }, [expandedCardKey, visibleCardKeys]);

  const getCardKey = item => item?.codigo || item?.cpf || item?.motorista || '';

  const handleExpandedCardChange = (item, nextExpanded) => {
    const cardKey = getCardKey(item);
    setExpandedCardKey(nextExpanded ? cardKey : null);
  };

  return (
    <PanelSection>
      <DisponibilidadeMotoristaFilter
        loading={loading}
        onApply={handleApplyFiltros}
        onLimpar={handleApplyFiltros}
        title={tituloFiltro}
        filters={filterConfig}
        collapseOnSearch={true}
      />

      <SectionHeader>
        <SectionTitle>{titulo}</SectionTitle>
        <Button variant="success" onClick={handleExportar}>
          <ButtonIconWrap>
            <GetAppIcon style={{ fontSize: 16 }} />
          </ButtonIconWrap>
          Exportar
        </Button>
      </SectionHeader>

      <DisponibilidadeMotoristaTable
        data={dataFiltrada}
        loading={loading}
        totalRegistros={dataFiltrada.length}
        paginaAtual={paginaAtual}
        quantidadePorPagina={quantidadePorPagina}
        setPaginaAtual={setPaginaAtual}
        setQuantidadePorPagina={setQuantidadePorPagina}
        enableCardView={true}
        defaultViewMode="table"
        renderCard={(item, meta) => (
          <MotoristaAvailabilityCard
            item={item}
            {...meta}
            onSelect={podeSelecionar ? itemSelecionado => onToggleSelection(tipo, itemSelecionado) : undefined}
            selected={isSameSelection(selecaoAtiva, tipo, item)}
            expanded={expandedCardKey === getCardKey(item)}
            onExpandedChange={nextExpanded => handleExpandedCardChange(item, nextExpanded)}
          />
        )}
        onRowClick={podeSelecionar ? item => onToggleSelection(tipo, item) : undefined}
      />
    </PanelSection>
  );
};

export default PainelDisponibilidadeMotorista;
